import { useIsMobile } from "../../hooks/useIsMobile";
import { MobileArrows } from "./MobileArrows";
import { DesktopArrows } from "./DesktopArrows";
import GroupSection from "./GroupSection";
import NoGroupSection from "./NoGroupSection";

export default function GroupManager() {
  const { isMobile } = useIsMobile;

  return (
    <>
      <div className="flex flex-row max-sm:flex-col justify-center items-center max-sm:gap-4 lg:gap-4 sm:gap-2 md:w-full p-4">
        <NoGroupSection />
        {isMobile ? <MobileArrows /> : <DesktopArrows />}

        <GroupSection />
      </div>
    </>
  );
}
